/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { BrightHorizonsCreditInactivity } from './model/brightHorizonsCreditInactivity';

export const apiBrightHorizonsCreditInactivityRetrieve = (signal?: AbortSignal) => {
  return HTTP<BrightHorizonsCreditInactivity>({
    url: `/api/v7/bright-horizons/credit-inactivity/`,
    method: 'GET',
    signal,
  });
};

export const getApiBrightHorizonsCreditInactivityRetrieveQueryKey = () => {
  return [`/api/v7/bright-horizons/credit-inactivity/`] as const;
};

export const getApiBrightHorizonsCreditInactivityRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiBrightHorizonsCreditInactivityRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiBrightHorizonsCreditInactivityRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiBrightHorizonsCreditInactivityRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiBrightHorizonsCreditInactivityRetrieve>>
  > = ({ signal }) => apiBrightHorizonsCreditInactivityRetrieve(signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiBrightHorizonsCreditInactivityRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiBrightHorizonsCreditInactivityRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiBrightHorizonsCreditInactivityRetrieve>>
>;
export type ApiBrightHorizonsCreditInactivityRetrieveQueryError = ErrorType<unknown>;

export function useApiBrightHorizonsCreditInactivityRetrieve<
  TData = Awaited<ReturnType<typeof apiBrightHorizonsCreditInactivityRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiBrightHorizonsCreditInactivityRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiBrightHorizonsCreditInactivityRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
